<template>
    <div id="resetPassowrd_v2" class="font-source-sans">
        <div class="reset_password_title mb-5">
            <p>
                Veuillez saisir votre <br/>
                nouveau mot de passe
            </p>
        </div>

        <div class="reset_password_auth">
            <p class="font-bold">Nouveau mot de passe</p>
            <div class="input_wrapper relative w-full mt-2 mb-6">
                <input ref="password" class="input_password" type="password" placeholder="Votre mot de passe" v-model="form_reset_password.password"/>
                <div class="key_img_wrapper">
                    <img src="img/auth/key.svg" alt=""/>
                </div>
                <div class="eye_img_wrapper cursor-pointer" @click="switchPasswordVisibility('password')">
                    <svg ref="eye" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16.5" height="11.25" viewBox="0 0 16.5 11.25">
                        <defs>
                            <clipPath id="clip-path">
                                <path
                                        id="Eye"
                                        d="M8.25,11.25A8.8,8.8,0,0,1,3.205,9.672,8.879,8.879,0,0,1,0,5.625a8.864,8.864,0,0,1,16.5,0,8.875,8.875,0,0,1-3.205,4.047A8.8,8.8,0,0,1,8.25,11.25Zm0-9.375A3.75,3.75,0,1,0,12,5.625,3.755,3.755,0,0,0,8.25,1.875Zm0,6a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,8.25,7.875Z"
                                        transform="translate(0.75 0.375)"
                                        fill="#dfe2e6"
                                />
                            </clipPath>
                        </defs>
                        <g id="Suche" transform="translate(-0.75 -0.375)">
                            <path
                                    id="Eye-2"
                                    data-name="Eye"
                                    d="M8.25,11.25A8.8,8.8,0,0,1,3.205,9.672,8.879,8.879,0,0,1,0,5.625a8.864,8.864,0,0,1,16.5,0,8.875,8.875,0,0,1-3.205,4.047A8.8,8.8,0,0,1,8.25,11.25Zm0-9.375A3.75,3.75,0,1,0,12,5.625,3.755,3.755,0,0,0,8.25,1.875Zm0,6a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,8.25,7.875Z"
                                    transform="translate(0.75 0.375)"
                                    :fill="isPasswordVisible ? '#4e4e4e' : '#dfe2e6'"
                            />
                        </g>
                    </svg>
                </div>
            </div>

            <p class="font-bold">Confirmer votre nouveau mot de passe</p>
            <div class="input_wrapper relative w-full mt-2 mb-6">
                <input ref="confirm_password" class="input_password" type="password" placeholder="Votre mot de passe" v-model="form_reset_password.confirm_password"/>
                <div class="key_img_wrapper">
                    <img src="img/auth/key.svg" alt=""/>
                </div>
                <div class="eye_img_wrapper cursor-pointer" @click="switchPasswordVisibility('confirm_password')">
                    <svg ref="eye" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16.5" height="11.25" viewBox="0 0 16.5 11.25">
                        <defs>
                            <clipPath id="clip-path">
                                <path
                                        id="Eye"
                                        d="M8.25,11.25A8.8,8.8,0,0,1,3.205,9.672,8.879,8.879,0,0,1,0,5.625a8.864,8.864,0,0,1,16.5,0,8.875,8.875,0,0,1-3.205,4.047A8.8,8.8,0,0,1,8.25,11.25Zm0-9.375A3.75,3.75,0,1,0,12,5.625,3.755,3.755,0,0,0,8.25,1.875Zm0,6a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,8.25,7.875Z"
                                        transform="translate(0.75 0.375)"
                                        fill="#dfe2e6"
                                />
                            </clipPath>
                        </defs>
                        <g id="Suche" transform="translate(-0.75 -0.375)">
                            <path
                                    id="Eye-2"
                                    data-name="Eye"
                                    d="M8.25,11.25A8.8,8.8,0,0,1,3.205,9.672,8.879,8.879,0,0,1,0,5.625a8.864,8.864,0,0,1,16.5,0,8.875,8.875,0,0,1-3.205,4.047A8.8,8.8,0,0,1,8.25,11.25Zm0-9.375A3.75,3.75,0,1,0,12,5.625,3.755,3.755,0,0,0,8.25,1.875Zm0,6a2.25,2.25,0,1,1,2.25-2.25A2.253,2.253,0,0,1,8.25,7.875Z"
                                    transform="translate(0.75 0.375)"
                                    :fill="isConfirmPasswordVisible ? '#4e4e4e' : '#dfe2e6'"
                            />
                        </g>
                    </svg>
                </div>
            </div>

            <div class="buttons-wrapper flex justify-between mb-5">
                <button type="button" class="btn valider-btn" @click="loginResetPassword">Valider</button>
            </div>
        </div>
    </div>
</template>

<script>
import Autentification from '@/services/Autentification';

export default {
    name: 'ResetPasswordV2',
    data() {
        return {
            isPasswordVisible: false,
            isConfirmPasswordVisible: false,

            form_reset_password: {
                token: '',
                email: '',
                password: '',
                confirm_password: ''
            }
        };
    },
    mounted() {
        let api_token = window.localStorage.getItem('api_token');
        this.$store.commit('setApiToken', api_token);
    },
    methods: {
        switchPasswordVisibility(input) {
            if (input === 'password') {
                this.isPasswordVisible = !this.isPasswordVisible;
                if (this.$refs.password.getAttribute('type') === 'password') this.$refs.password.setAttribute('type', 'text');
                else this.$refs.password.setAttribute('type', 'password');
            }
            if (input === 'confirm_password') {
                this.isConfirmPasswordVisible = !this.isConfirmPasswordVisible;
                if (this.$refs.confirm_password.getAttribute('type') === 'password') this.$refs.confirm_password.setAttribute('type', 'text');
                else this.$refs.confirm_password.setAttribute('type', 'password');
            }
        },
        clearConfirmPassword() {
            var self = this;
            self.form_reset_password.password = '';
            self.form_reset_password.confirm_password = '';
            self.form_reset_password.token = '';
        },
        loginResetPassword() {
            var self = this;
            // preia datele
            self.form_reset_password.password = self.form_reset_password.password.trim();
            self.form_reset_password.confirm_password = self.form_reset_password.confirm_password.trim();
            self.form_reset_password.token = self.$store.state.query_token;
            //
            // valideaza datele
            if (self.form_reset_password.password.length === 0) {
                $eventbus.$emit('open:alert', 'Merci de préciser votre mot de passe.');
            } else if (self.form_reset_password.password.length < 6) {
                $eventbus.$emit('open:alert', 'La valeur du mot de passe doit être au moins 6 caractères.');
            } else if (self.form_reset_password.password !== self.form_reset_password.confirm_password) {
                $eventbus.$emit('open:alert', 'Merci pour les mots de passe, mais ils ne correspondent pas.');
            } else {
                Autentification.confirm_password({
                    kta_id: '',
                    // token: self.form_reset_password.token,
                    token: self.$store.state.query_token || self.form_reset_password.token,
                    email: self.$store.state.query_email || self.form_reset_password.email,
                    password: self.form_reset_password.password,
                    confirm_password: self.form_reset_password.confirm_password
                })
                        .then((result) => {
                            var data = result.data;

                            if (data && data.error) {
                                console.log(111, data);
                                $eventbus.$emit('open:alert', data.error.message);
                            } else {

                                console.log(222, data.data);
                                $eventbus.$emit('open:alert', data.data.message);
                                $eventbus.$emit('toggle:modal');

                                let sto = setTimeout(function () {
                                    clearTimeout(sto);

                                    if (window.parent && window.parent.MainFrame) {
                                        let MainFrame = window.parent.MainFrame;
                                        let mailSentTrigger = 'mailSentFromForm';

                                        MainFrame.Manager.Variables.register("loggedOut", "1");

                                        MainFrame.Manager.Variables.register("api_token", "0");
                                        MainFrame.EprintShop.saveItem("api_token", null);

                                        // MainFrame.EventHandler.dispatch(mailSentTrigger);

                                        MainFrame.EventHandler.dispatch('closeLogin');
                                        MainFrame.EventHandler.dispatch('loginSuccess');
                                        MainFrame.EventHandler.dispatch("userNotLoggedIn");
                                    }

                                }, 4000);

                            }
                        })
                        .catch((error) => {
                            $eventbus.$emit('open:alert', 'Le formulaire comporte une erreur. Veuillez vérifier les informations.');
                        })
                        .then(() => {
                            self.clearConfirmPassword();
                        });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
#resetPassowrd_v2 {
    width: 100%;
    max-width: 350px;
    padding: 1rem 0;

    .reset_password_title {
        font-size: 22px;
        font-weight: bold;
    }

    .reset_password_auth {
        * {
            user-select: none;
        }

        p {
            font-size: 12px;
            color: #6b6c6f;
        }

        .input_wrapper {
            position: relative;

            input {
                width: 100%;
                border: 1px solid #dfe2e6;
                border-radius: 25px;
                padding-block: 0.3rem;
                padding-inline: 3rem;
                outline: none;
                font-size: 13px;
                color: #6b6c6f;

                &::placeholder {
                    font-weight: bold;
                    opacity: 0.5;
                    font-size: 13px;
                }

                &:focus {
                    border-color: #6b6c6f;
                }
            }

            .email_img_wrapper {
                position: absolute;
                top: 50%;
                left: 25px;
                translate: -50% -50%;
                width: 20px;

                img {
                    width: 100%;
                    display: block;
                    height: auto;
                }
            }

            .key_img_wrapper {
                position: absolute;
                top: 50%;
                left: 25px;
                translate: -50% -50%;
                width: 20px;

                img {
                    width: 100%;
                    display: block;
                    height: auto;
                }
            }

            .eye_img_wrapper {
                position: absolute;
                top: 50%;
                right: 0.2rem;
                translate: -50% -50%;
                width: 16.5px;

                img {
                    width: 100%;
                    display: block;
                    height: auto;
                }
            }
        }

        .buttons-wrapper {
            .btn {
                font-size: 14px;
                outline: none;
                border: none;
                width: 100%;
                max-width: 160px;
                height: 40px;
                border-radius: 2rem;
                font-weight: 500;
                user-select: none;
                // &.sign-up-btn {
                //     border: 2px solid #4e4e4e;
                //     color: #4e4e4e;
                // }
                &.valider-btn {
                    color: white;
                    background-color: #4e4e4e;
                }
            }
        }
    }
}
</style>
